import { render, staticRenderFns } from "./ModalConfirmationDelete.vue?vue&type=template&id=270bf339&"
import script from "./ModalConfirmationDelete.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports